export default __webpack_public_path__ + "static/media/manufacturing.2728e8c7.svg";